/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { jsx } from '@compiled/react';
import { FormattedDate } from 'react-intl-next';
interface EventDateTimeProps {
	timestamp?: string;
}

export const EventDateTime = ({ timestamp }: EventDateTimeProps): JSX.Element | null => {
	if (!timestamp) {
		return null;
	}

	return (
		<FormattedDate
			value={timestamp}
			year="numeric"
			month="short"
			day="2-digit"
			hour="numeric"
			minute="numeric"
			timeZoneName="short"
		/>
	);
};
